import { css } from '@emotion/css'
import { theme } from '../../styled'

export const tooltipTitleCss = css`
  font-weight: ${theme.fontWeights.secondary.boldest};
  padding-bottom: 4px;
`
